import { BiSolidCategory } from 'react-icons/bi'
import { PiMedalFill } from 'react-icons/pi'
import { FaStore, FaTags, FaUserCog, FaUsers, FaUsersCog } from 'react-icons/fa'
import { LuLayoutDashboard } from 'react-icons/lu'
import { GrTransaction, GrUserManager } from 'react-icons/gr'
import { FaBuildingUser, FaBoxOpen } from 'react-icons/fa6'
import { MdOutlinePlaylistAdd } from 'react-icons/md'
import { ImBoxAdd } from 'react-icons/im'
import { BsBank, BsCart4 } from 'react-icons/bs'
import { IoAnalytics } from 'react-icons/io5'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/user',
                text: 'Dashboard',
                permission: 'dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/user/roles'],
                url: '/user/roles',
                text: 'Roles',
                permission: 'roles.index',
                icon: <FaUserCog />,
            },
            {
                active: ['/user/users'],
                url: '/user/users',
                text: 'Users',
                permission: 'users.index',
                icon: <FaUsersCog />,
            },
            {
                active: ['/user/stores'],
                url: '/user/stores',
                text: 'Stores',
                permission: 'stores.index',
                icon: <FaStore />,
            },
            {
                active: ['/user/store-users'],
                url: '/user/store-users',
                text: 'Store Users',
                permission: 'store_users.index',
                icon: <FaBuildingUser />,
            },
            {
                active: ['/user/bank-accounts'],
                url: '/user/bank-accounts',
                text: 'Bank Accounts',
                permission: 'bank_accounts.index',
                icon: <BsBank />,
            },
            {
                active: ['/user/bank-transactions'],
                url: '/user/bank-transactions',
                text: 'Bank Transactions',
                permission: 'bank_transactions.index',
                icon: <GrTransaction />,
            },
            {
                active: ['/user/wallet-transactions'],
                url: '/user/wallet-transactions',
                text: 'Wallet Transactions',
                permission: 'wallet_transactions.index',
                icon: <GrTransaction />,
            },
            {
                active: ['/user/customers'],
                url: '/user/customers',
                text: 'Customers',
                permission: 'customers.index',
                icon: <FaUsers />,
            },
            {
                active: ['/user/vendors'],
                url: '/user/vendors',
                text: 'Vendors',
                permission: 'vendors.index',
                icon: <GrUserManager />,
            },
            {
                active: ['/user/referrals'],
                url: '/user/referrals',
                text: 'Referrals',
                permission: 'referrals.index',
                icon: <GrUserManager />,
            },
            {
                active: ['/user/brands', '/user/categories', '/user/attributes', '/user/expenses'],
                text: 'Masters',
                icon: <MdOutlinePlaylistAdd />,
                child: [
                    {
                        active: ['/user/brands'],
                        url: '/user/brands',
                        text: 'Brands',
                        permission: 'brands.index',
                        icon: <PiMedalFill />,
                    },
                    {
                        active: ['/user/categories'],
                        url: '/user/categories',
                        text: 'Categories',
                        permission: 'categories.index',
                        icon: <BiSolidCategory />,
                    },
                    {
                        active: ['/user/attributes'],
                        url: '/user/attributes',
                        text: 'Attributes',
                        permission: 'attributes.index',
                        icon: <FaTags />,
                    },
                    {
                        active: ['/user/expenses'],
                        url: '/user/expenses',
                        text: 'Expenses',
                        permission: 'expenses.index',
                        icon: <PiMedalFill />,
                    },
                ],
            },
            {
                active: ['/user/products'],
                url: '/user/products',
                text: 'Products',
                permission: 'products.index',
                icon: <FaBoxOpen />,
            },
            {
                active: ['/user/purchases'],
                url: '/user/purchases',
                text: 'Purchases',
                permission: 'purchases.index',
                icon: <ImBoxAdd />,
            },
            {
                active: ['/user/store-orders'],
                url: '/user/store-orders',
                text: 'Store Orders',
                permission: 'store_orders.index',
                icon: <BsCart4 />,
            },
            {
                active: ['/user/orders'],
                url: '/user/orders',
                text: 'Customer Orders',
                permission: 'orders.index',
                icon: <BsCart4 />,
            },
            {
                active: ['/user/analysis'],
                text: 'Analysis',
                icon: <IoAnalytics />,
                permission: ['purchases.products', 'store_orders.products', 'orders.products'],
                child: [
                    {
                        active: ['/user/analysis/purchases'],
                        url: '/user/analysis/purchases',
                        text: 'Purchases',
                        permission: 'purchases.products',
                        icon: <ImBoxAdd />,
                    },
                    {
                        active: ['/user/analysis/store-orders'],
                        url: '/user/analysis/store-orders',
                        text: 'Store Orders',
                        permission: 'store_orders.products',
                        icon: <BsCart4 />,
                    },
                    {
                        active: ['/user/analysis/orders'],
                        url: '/user/analysis/orders',
                        text: 'Customer Orders',
                        permission: 'orders.products',
                        icon: <BsCart4 />,
                    },
                ],
            },
        ],
    },
]

export default appRoutes
